<template>
	<TopMenu/>
	<RouterView/>
</template>

<script>
import TopMenu from '@/widgets/TopMenu.vue';
import { RouterView } from 'vue-router'

export default {
  components: { TopMenu, RouterView },
}

</script>

<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

#app {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	overflow-x: hidden;
	position: relative;
}
.content {
	flex-grow: 1;
}
</style>
